import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useAvailableRarities } from '#src/hooks/my-cards/useAvailableRarities.tsx';

export const useFilteredShardsChests = () => {
  const { currentUser } = useCurrentUserContext();
  const availableRarities = useAvailableRarities();
  const { cardShardsChests } = currentUser || {};

  return cardShardsChests?.filter(shard =>
    availableRarities.includes(shard.rarity)
  );
};
